export default __webpack_public_path__ + "static/media/tomeoferlik.95eb530f.png";